module.exports = __webpack_public_path__ + "static/img/testimony (89).3c213634.jpg";